/* eslint-disable react-hooks/exhaustive-deps */
import React, { ChangeEvent, useEffect, useState } from 'react';
import Input from 'components/Fields/Input';

import { useSpecSheet } from 'containers/spec-sheet';
import { useDebounce } from 'hooks/useDebounce';

const Outsole: React.FC = () => {
  const {
    data: { data },
    actions,
  } = useSpecSheet();

  const outsoleDesignNo = data?.outsoleDesignNo || '';

  const [value, setValue] = useState(outsoleDesignNo);

  const handleChange = ({
    target: { value },
  }: ChangeEvent<HTMLInputElement>) => {
    setValue(value);
  };

  const saveChange = async () =>
    actions.changeSpecSheetData({ outsoleDesignNo: value.trim() });

  const autoSave = useDebounce(value);

  const handleSave = () => {
    if (outsoleDesignNo !== value) saveChange();
  };

  useEffect(() => {
    handleSave();
  }, [autoSave]);

  const isCompleted = !!value;

  return (
    <Input
      label="Outsole Design No."
      value={value}
      name="outsole"
      onChange={handleChange}
      dataTest="outsole"
      isCompleted={isCompleted}
      handleBlur={() => handleSave()}
      placeholder="Click to add"
    />
  );
};

export default Outsole;
